import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useMemo } from 'react';
import { mergeRefs } from '@elliemae/ds-utilities/system';
import FocusGridManager from '@elliemae/ds-shared/FocusGroup/FocusGrid';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import paginate from './helper.js';
import { usePaginationState } from './usePaginationState.js';
import NoResults from '../../components/NoResults.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';
import 'styled-components';
import '@elliemae/ds-system';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var composeRows = function composeRows(rows, grid) {
  var _grid$getInstance = grid.getInstance(),
      pagination = _grid$getInstance.state.pagination,
      groupedRows = _grid$getInstance.props.groupedRows;

  if (groupedRows) return rows; // disable pagination with grouping

  if (groupedRows) {
    var filterIds = rows.map(function (r) {
      return r.id;
    });
    return paginate(rows.filter(function (c) {
      return filterIds.includes(c.id);
    }).map(function (r) {
      return _objectSpread(_objectSpread({}, r), {}, {
        _isGroup: r.isGroup
      });
    }), pagination);
  }

  return paginate(rows, pagination);
};

var Body = /*#__PURE__*/React.memo(function (_ref) {
  var Component = _ref.component,
      rows = _ref.rows,
      rowRenderer = _ref.rowRenderer,
      noResultsPlaceholder = _ref.noResultsPlaceholder,
      innerRef = _ref.innerRef;
      _ref.innerBodyRef;
      var _ref$isPlaceholderAct = _ref.isPlaceholderActive,
      isPlaceholderActive = _ref$isPlaceholderAct === void 0 ? false : _ref$isPlaceholderAct,
      otherBodyProps = _objectWithoutProperties(_ref, ["component", "rows", "rowRenderer", "noResultsPlaceholder", "innerRef", "innerBodyRef", "isPlaceholderActive"]);

  return /*#__PURE__*/React.createElement(Component, _extends({}, otherBodyProps, {
    innerRef: mergeRefs(innerRef)
  }), !isPlaceholderActive ? rows.map(function (row, index) {
    return rowRenderer(row, {
      index: index,
      rowIndex: index
    }, {});
  }) : /*#__PURE__*/React.createElement(NoResults, {
    innerRef: innerRef,
    rowRenderer: rowRenderer
  }, noResultsPlaceholder));
});

var decorateRenderers = function decorateRenderers(renderers, grid) {
  var BodyWrapper = renderers.body.wrapper;
  renderers.body.wrapper = useMemo(function () {
    return function (props) {
      var _grid$getInstance2 = grid.getInstance(),
          hotKeys = _grid$getInstance2.hotKeys;
          _grid$getInstance2.shouldRefocus;
          _grid$getInstance2.state;

      return /*#__PURE__*/React.createElement(FocusGridManager, {
        hotKeys: hotKeys,
        shouldRefocus: false
      }, /*#__PURE__*/React.createElement(Body, _extends({}, props, {
        component: BodyWrapper
      })));
    };
  }, []);
  return renderers;
};

var PaginationPlugin = createInstancePlugin('pagination', {
  registerStateHook: usePaginationState,
  decorateRenderers: decorateRenderers,
  composeRows: composeRows
});

export { PaginationPlugin };
//# sourceMappingURL=PaginationPlugin.js.map
